export class ParseXml {
  public static parseNode = (node: Node): string | undefined | Record<string, unknown> | null => {
    const childAttributes: Node[] = node instanceof Element ? Array.prototype.slice.call(node.attributes) : [];
    const childNodes: Node[] = Array.prototype.slice.call(node.childNodes).concat(childAttributes);
    if (childNodes.length === 0) {
      return node.nodeValue;
    } else if (childNodes.length === 1 && childNodes[0].nodeType === Node.TEXT_NODE) {
      return childNodes[0].nodeValue?.trim();
    } else if (childNodes[0].nodeType === Node.TEXT_NODE && childAttributes.length > 0) {
      const attribures = childAttributes.reduce((acc, node) => {
        return { ...acc, [node.nodeName]: node.nodeValue };
      }, {});
      return { value: childNodes[0].nodeValue, ...attribures };
    } else {
      const obj: Record<string, unknown> = {};
      childNodes.forEach((childNode) => {
        const childName = childNode.nodeName;
        const childValue = obj[childName];
        if (childValue !== undefined) {
          if (Array.isArray(childValue)) {
            childValue.push(ParseXml.parseNode(childNode));
          } else {
            obj[childName] = [childValue, ParseXml.parseNode(childNode)];
          }
        } else if (childName !== '#text') {
          obj[childName] = ParseXml.parseNode(childNode);
        }
      });
      return obj;
    }
  };

  public static parseString = <T>(str: string): T => {
    return this.parseNode(new DOMParser().parseFromString(str.replace(/&AMP;/g, '&amp;').trim(), 'text/xml')) as T;
  };
  public static decodeXml = (str: string): string => {
    return new DOMParser().parseFromString(`<!doctype html><body>${str}`, 'text/html').body?.textContent ?? '';
  };
}
